export type DashboardView =
  | 'executive'
  | 'administrator'
  | 'chief-registrar'
  | 'deputy-chief-registrar'
  | 'registrar'
  | 'accounting'
  | 'chief-accountant'
  | 'finance'
  | 'dokuma-finance';
export type DashboardCell = string | number | null;
export interface DashboardOption {
  id: string;
  label: string;
}
export interface DashboardFilters {
  from: string;
  to: string;
  officeId?: string;
  serviceType?: string[];
  stage?: string;
  currency: string;
  lawFirmId?: string;
  userId?: string;
  status?: string;
  paymentChannel?: string;
  invoiceNumber?: string;
}
export interface DashboardLifecycle {
  applicationType: string;
  label: string;
  entryStatuses: string[];
  terminalStatus: string;
}
export interface DashboardConfig {
  views: { id: DashboardView; label: string }[];
  defaultView: DashboardView;
  offices: DashboardOption[];
  serviceTypes: DashboardOption[];
  stages: DashboardOption[];
  lifecycles: DashboardLifecycle[];
  currencies: DashboardOption[];
  lawFirms: DashboardOption[];
  users: DashboardOption[];
  statuses: DashboardOption[];
  paymentChannels: DashboardOption[];
  lockedOfficeId: string | null;
  timezone: string;
  asOf: string;
  mock: boolean;
}
export interface DashboardMetric {
  id: string;
  label: string;
  value: number | null;
  unit: 'count' | 'money' | 'percent' | 'days';
  scope: 'period' | 'as-of';
  description: string;
}
export interface DashboardColumn {
  key: string;
  label: string;
}
export interface DashboardRow {
  id: string;
  [key: string]: DashboardCell;
}
export interface DashboardPanel {
  id: string;
  title: string;
  description: string;
  kind: 'bars' | 'table' | 'line' | 'stacked-bars';
  series?: { key: string; label: string }[];
  unit: DashboardMetric['unit'];
  scope: DashboardMetric['scope'];
  columns: DashboardColumn[];
  rows: DashboardRow[];
  totalElements: number;
}
export interface DashboardResult {
  view: DashboardView;
  asOf: string;
  timezone: string;
  currency: string;
  mock: boolean;
  filters: DashboardFilters;
  metrics: DashboardMetric[];
  panels: DashboardPanel[];
}
export interface DashboardBreakdown {
  title: string;
  items: { id: string; label: string; value: number }[];
  total: number;
}
export interface DashboardMatrix {
  title: string;
  rowHeader: string;
  columns: { id: string; label: string }[];
  rows: {
    id: string;
    label: string;
    values: Record<string, number>;
    total: number;
  }[];
  columnTotals: Record<string, number>;
  total: number;
}
export interface DashboardDetail {
  title: string;
  breakdown?: DashboardBreakdown;
  matrix?: DashboardMatrix;
  columns: DashboardColumn[];
  content: DashboardRow[];
  totalElements: number;
  pageNumber: number;
  pageSize: number;
}
export const OPERATIONS_DASHBOARD_PATH = '/dashboard/operations';
